import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Aguardando from '../common/template/aguardando';
import { MapLeaflet } from "../common/mapLeaflet/MapLeaflet";
import Cookies from 'js-cookie';
import consts from '../consts';
import iconeBandeira from '../assets/images/icone_bandeira.png';
import iconeViagemAberta from '../assets/images/icone_viagem_aberta.png';
import iconeRelogio from '../assets/images/icone_relogio.png';
import iconeCaminhaoVerde from '../assets/map/marker_truck_direita_success.png';
import iconeCaminhaoVermelho from '../assets/map/marker_truck_direita_danger.png';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import { 
	setModoTela, setFiltro, getListaFronteiras, getListaNegociadores, getListaOperacoes, getLista, getListaOcorrencias, getListaCards,
	getConfiguracao, alterarConfiguracao
} from './reportsInconformidadeActions';
import {
	buscarPermissao
} from '../auth/authActions';
import { registrarAcesso } from '../analiseAcesso/analiseAcessoActions';
import Select from '../common/form/select';
import SelectNovo from '../common/form/selectNovo';
import SwitchVertical from '../common/form/switchVertical';
import SelectDialog from '../common/form/selectDialog';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';

class ReportsInconformidade extends Component {

	state = {
		modoTela: 'lista',
		linhaSelecionada: null,
		pesquisar: '',
		pesquisarAux: '',
		idShippingExpandido: null,
		resumido: true,
		registroModal: null,
		registroModalOcorrencia: null,
		listaFavoritos: JSON.parse(Cookies.get('shippingsFavoritos') || '[]'),
		listaPeriodo: [
			{ id: 'DATA_PREVISAO_CARGA', valor: 'Previsão Carga' },
			{ id: 'DATA_INICIO_CARGA', valor: 'Chegada Carga' },
			{ id: 'DATA_TERMINO_CARGA', valor: 'Saída Carga' },
			{ id: 'DATA_ENTRADA_ADUANA_ORIGEM', valor: 'Chegada Aduana Origem' },
			{ id: 'DATA_LIBERACAO_ADUANA_ORIGEM', valor: 'Liberação Aduana Origem' },
			{ id: 'DATA_PREV_FRONTEIRA', valor: 'Previsão Fronteira' },
			{ id: 'DATA_ENTRADA_FRONTEIRA', valor: 'Chegada Fronteira' },
			{ id: 'DATA_AUTORIZACAO_INGRESSO_FRONTEIRA', valor: 'Autorização Ingresso fronteira' },
			{ id: 'DT_ENTRADA_ADUANA_FRONT_ORG', valor: 'Chegada Aduana Fronteira Origem' },
			{ id: 'DT_LIBERACAO_ADUANA_FRONT_ORG', valor: 'Liberação Aduana Fronteira Origem' },
			{ id: 'DT_ENTRADA_ADUANA_FRONT_DEST', valor: 'Chegada Aduana Fronteira Destino' },
			{ id: 'DT_LIBERACAO_ADUANA_FRONT_DEST', valor: 'Liberação Aduana Fronteira Destino' },
			{ id: 'DATA_LIBERACAO_FRONTEIRA', valor: 'Liberação Fronteira	' },
			{ id: 'DATA_ENTRADA_ADUANA_DESTINO', valor: 'Chegada Aduana Destino' },
			{ id: 'DATA_LIBERACAO_ADUANA_DESTINO', valor: 'Liberação Aduana Destino' },
			{ id: 'DATA_PREVISAO_DESCARGA', valor: 'Previsão Descarga' },
			{ id: 'DATA_INICIO_DESCARGA', valor: 'Chegada Descarga' },
			{ id: 'DATA_TERMINO_DESCARGA', valor: 'Saída Descarga' }
		],
		filtro: {
			tipo_periodo: 'DATA_PREVISAO_CARGA',
			data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(31)),
			data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
			aberto: true,
			finalizado: false,
			semNaoInconformidade: false,
			comNaoInconformidade: true,
			rumos: [],
			farolAtrasos: [],
			fronteiras: [],
			operacoes: [],
			negociadores: [],
			/*rumos: [],
			farolAtrasos: [],
			fronteiras: [],
			operacoes: [],
			negociadores: [],
			lote: false,
			classificada: false,
			expressa: false,			
			ocorrenciaAberta: false,
			cavaloEngatado: false,
			somenteCarreta: false,
			semConjunto: false,
			emCD: false,
			semDocumento: false,*/
			nacional: this.props.usuarioCarregado ? this.props.usuarioCarregado.nacional : false,
			internacional: this.props.usuarioCarregado ? this.props.usuarioCarregado.internacional : false,
			ocorrencia_aberta: false,
			transit_time_atraso: false,
			classificada: false
		},
		ordenacao: {
			ocorrencia: 0,
			transit_time: 2,
			shipping: 0,
			solicitacao: 0,
			classificada: 0,
			previsao_carga: 0,
			inicio_carga: 0,
			termino_carga: 0,
			entrada_aduana_origem: 0,
			liberacao_aduana_origem: 0,
			previsao_fronteira: 0,
			entrada_fronteira: 0,
			autorizacao_ingresso_fronteira: 0,
			entrada_aduana_front_org: 0,
			liberacao_aduana_front_org: 0,
			entrada_aduana_front_dest: 0,
			liberacao_aduana_front_dest: 0,
			liberacao_fronteira: 0,
			entrada_aduana_destino: 0,
			liberacao_aduana_destino: 0,
			previsao_descarga: 0,
			inicio_descarga: 0,
			termino_descarga: 0,
			fatura: 0,
			observacao: 0,
			documento: 0,
			cavalo: 0,
			carreta: 0,
			cliente: 0,
			remetente: 0,
			destinatario: 0,
			rota: 0,
			fronteira: 0,
			indicador_carga: 0,
			indicador_fronteira: 0,
			indicador_descarga: 0,
			indicador_permanencia_carga: 0,
			indicador_permanencia_fronteira: 0,
			indicador_permanencia_descarga: 0,
			lead_time: 0,

			/*documentos: 0,
			cavalo: 0,
			carreta: 0,
			lote: 0,
			classificada: 0,
			expressa: 0,
			ocorrencia: 0,
			cliente: 0,
			rota: 0,
			fronteira: 0,
			previsao: 0,
			statusPrevisao: 0,
			posicao: 0,
			statusPosicao: 0,
			destinado: 0*/
		}
	}

    componentWillMount() {
		this.props.getListaFronteiras();
		this.props.getListaNegociadores();
		this.props.getListaOperacoes();
        this.props.getLista(this.state.filtro);
		this.props.getListaCards();
		this.props.getConfiguracao();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getListaFronteiras();
			this.props.getListaNegociadores();
			this.props.getListaOperacoes();
			this.props.getLista(this.state.filtro);
			this.props.getListaCards();
			this.props.getConfiguracao();
		}, 120000);
    }

	async componentDidMount() {

		document.addEventListener('keydown', this.handleKeyDown);

		this.permissaoTela = await this.props.buscarPermissao('/reportsInconformidade');
		this.permissaoConfigurar = this.permissaoTela && this.permissaoTela.permissoes.filter(item => item.id == 21 && item.liberado).length > 0;	

		//Início do registro de Análise Tela
		this.timeEntrouTela = Date.now();
		this.idEntrouTela = setInterval(() => {
			this.props.registrarAcesso('Inconformidade', this.props.location.pathname, Date.now() - this.timeEntrouTela);
			this.timeEntrouTela = Date.now();
		}, 60000);
		//Fim do registro de Análise Tela
	}
	
	componentWillUnmount() {
		
		document.removeEventListener('keydown', this.handleKeyDown);

		//Início do encerramento de Análise Tela
		clearInterval(this.idEntrouTela);
		this.props.registrarAcesso('Inconformidade', this.props.location.pathname, Date.now() - this.timeEntrouTela);
		//Fim do encerramento de Análise Tela

		clearInterval(this.idIntervalAtualizacao);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({ ...this.state, registroConfiguracao: null });
		}
	};

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.montarTela()}

                </Content>
            </div>
        )
    }

	filtrar() {

		let acessoCliente = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente;

		let lista = this.props.lista

			.filter(item => {
				if (this.props.usuarioCarregado && (this.props.usuarioCarregado.placas_cco || []).length > 0) {
					return (this.props.usuarioCarregado.placas_cco || []).filter(placa => placa == item.cavalo).length > 0;
				} else {
					return this.props.usuarioCarregado ? true : false;
				}
			})

			.filter(item => {
				if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente) {
					return (this.props.usuarioCarregado.id_negociadores || []).filter(negociador => negociador == item.id_negociador).length > 0;
				} else {
					return true;
				}
			})

			.filter(item => {
				if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente && (this.props.usuarioCarregado.id_operacoes || []).length > 0) {
					return (this.props.usuarioCarregado.id_operacoes || []).filter(operacao => operacao == item.operacao_id).length > 0;
				} else {
					return true;
				}
			})

			.filter(item => {
				if (this.props.usuarioCarregado && (this.props.usuarioCarregado.nome_fronteiras || []).length > 0) {
					return (this.props.usuarioCarregado.nome_fronteiras || []).filter(fronteira => fronteira == item.fronteira).length > 0;
				} else {
					return true;
				}
			})

			//FILTROS SELECT
			.filter(item => {

				if ((this.state.filtro.rumos || []).length && !this.state.filtro.rumos.filter(itemFiltro => itemFiltro == item.rumo).length) {
					return false;
				}
				if ((this.state.filtro.fronteiras || []).length && !this.state.filtro.fronteiras.filter(itemFiltro => itemFiltro == item.nome_fronteira).length) {
					return false;
				}
				if ((this.state.filtro.operacoes || []).length 
					&& !this.state.filtro.operacoes.filter(itemFiltro => 
						(this.props.listaOperacoes.filter(operacao => operacao.id == itemFiltro)[0] ? this.props.listaOperacoes.filter(operacao => operacao.id == itemFiltro)[0].valor : null)
						 == item.descricao_operacao).length) {
					return false;
				}
				if ((this.state.filtro.negociadores || []).length && !this.state.filtro.negociadores.filter(itemFiltro => itemFiltro == item.id_negociador).length) {
					return false;
				}

				return true;
			})

			//FILTROS SWITCH
			.filter(item => {
				if (!this.state.filtro.aberto || !this.state.filtro.finalizado) {
					if (!this.state.filtro.aberto && !this.state.filtro.finalizado) {
						return false;
					} else if (this.state.filtro.aberto && item.finalizado) {
						return false;
					} else if (this.state.filtro.finalizado && !item.finalizado) {
						return false;
					}					
				}
				
				/*
				if (this.state.filtro.lote && !item.lote) {
					return false;
				}
				if (this.state.filtro.classificada && !item.classificada) {
					return false;
				}
				if (this.state.filtro.expressa && !item.expressa) {
					return false;
				}
				if (this.state.filtro.ocorrenciaAberta && !item.ocorrencias_abertas) {
					return false;
				}
				if (this.state.filtro.cavaloEngatado && !item.cavalo) {
					return false;
				}
				if (this.state.filtro.somenteCarreta && !item.carreta) {
					return false;
				}
				if (this.state.filtro.semConjunto && (item.cavalo || item.carreta)) {
					return false;
				}
				if (this.state.filtro.semDocumento && item.qtd_documentos > 0) {
					return false;
				}*/
				if (!this.state.filtro.nacional || !this.state.filtro.internacional) {
					//Se não tem rumo significa que ainda não foram registrados eventos no shipping
					if (!this.state.filtro.nacional && !this.state.filtro.internacional) {
						return item.rumo == 'INDEFINIDO';
					}
					if (this.state.filtro.nacional && item.rumo != 'NAC') {
						return false;
					}
					if (this.state.filtro.internacional && item.rumo == 'NAC') {
						return false;
					}
				}
				
				if (this.state.filtro.ocorrencia_aberta && item.ocorrencias_abertas <= 0) {
					return false;
				}


				let transitTimeAtraso = false;
				if (item.transit_time < 100 && item.datahora_previsao_real) {
					if (!item.data_inicio_carga) {
						if (item.data_previsao_carga && new Date(item.datahora_previsao_real).getTime() > new Date(item.data_previsao_carga).getTime()) {
							transitTimeAtraso = true;
						}
					} else if (item.fronteira && item.data_termino_carga && !item.data_entrada_fronteira) {
						if (item.data_prev_fronteira && new Date(item.datahora_previsao_real).getTime() > new Date(item.data_prev_fronteira).getTime()) {
							transitTimeAtraso = true;
						}
					} else if (((!item.fronteira && item.data_termino_carga) || (item.fronteira && item.data_liberacao_fronteira)) && !item.data_inicio_descarga) {
						if (item.data_previsao_descarga && new Date(item.datahora_previsao_real).getTime() > new Date(item.data_previsao_descarga).getTime()) {
							transitTimeAtraso = true;
						}
					}
				}

				if (this.state.filtro.transit_time_atraso && !transitTimeAtraso) {
					return false;
				}

				if (this.state.filtro.classificada && !item.classificada) {
					return false;
				}
				
				return true;

			})
			//FILTRO BUSCA TEXTO
			.filter(item => {

				return !(this.state.pesquisar || '').trim()
					|| (this.state.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
					if (pesquisar
						&& !(`
							${item.solicitacao_carga_id || ''}
							${item.shipping_code_id || ''}
							${item.cavalo || ''}
							${item.carreta || ''}
							${item.negociador || ''}
							${item.rota || ''}
							${item.nome_fronteira || ''}
							${item.posicao || ''}
							${item.datahora_inicio_formatada || ''}
							${item.tempo || ''}
							${item.nome_tipo || ''}
						`).toUpperCase().includes(pesquisar)) {
						return false;
					}

					return true;

				}).length > 0;

			});

			if (this.state.ordenacao.solicitacao) {
				lista.sort((a, b) => this.state.ordenacao.solicitacao == 1 
					? (parseInt(a.solicitacao_carga_id) > parseInt(b.solicitacao_carga_id) ? 1 : -1) 
					: (parseInt(a.solicitacao_carga_id) > parseInt(b.solicitacao_carga_id) ? -1 : 1));
			} else if (this.state.ordenacao.shipping) {
				lista.sort((a, b) => this.state.ordenacao.shipping == 1 
					? (parseInt(a.shipping_code_id) > parseInt(b.shipping_code_id) ? 1 : -1) 
					: (parseInt(a.shipping_code_id) > parseInt(b.shipping_code_id) ? -1 : 1));
			} else if (this.state.ordenacao.cavalo) {
				lista.sort((a, b) => this.state.ordenacao.cavalo == 1 
					? ((a.cavalo || '0') > (b.cavalo || '0') ? 1 : -1) 
					: ((a.cavalo || '0') > (b.cavalo || '0') ? -1 : 1));
			} else if (this.state.ordenacao.carreta) {
				lista.sort((a, b) => this.state.ordenacao.carreta == 1 
					? ((a.carreta || '0') > (b.carreta || '0') ? 1 : -1) 
					: ((a.carreta || '0') > (b.carreta || '0') ? -1 : 1));
			} else if (this.state.ordenacao.cliente) {
				lista.sort((a, b) => this.state.ordenacao.cliente == 1 
					? (a.negociador > b.negociador ? 1 : -1) 
					: (a.negociador > b.negociador ? -1 : 1));
			} else if (this.state.ordenacao.rota) {
				lista.sort((a, b) => this.state.ordenacao.rota == 1 
					? (a.rota > b.rota ? 1 : -1) 
					: (a.rota > b.rota ? -1 : 1));
			} else if (this.state.ordenacao.fronteira) {
				lista.sort((a, b) => this.state.ordenacao.fronteira == 1 
					? ((a.nome_fronteira || 'a') > (b.nome_fronteira || 'a') ? 1 : -1) 
					: ((a.nome_fronteira || 'a') > (b.nome_fronteira || 'a') ? -1 : 1));			
			} else if (this.state.ordenacao.posicao) {
				lista.sort((a, b) => this.state.ordenacao.posicao == 1 
					? ((a.posicao || 'a') > (b.posicao || 'a') ? 1 : -1) 
					: ((a.posicao || 'a') > (b.posicao || 'a') ? -1 : 1));			
			} else if (this.state.ordenacao.datahora_inicio_formatada) {
				lista.sort((a, b) => this.state.ordenacao.datahora_inicio_formatada == 1 
					? (new Date(a.datahora_inicio_formatada || null) > new Date(b.datahora_inicio_formatada || null) ? 1 : -1)
					: (new Date(a.datahora_inicio_formatada || null) > new Date(b.datahora_inicio_formatada || null) ? -1 : 1));
			} else if (this.state.ordenacao.datahora_fim_formatada) {
				lista.sort((a, b) => this.state.ordenacao.datahora_fim_formatada == 1 
					? (new Date(a.datahora_fim_formatada || null) > new Date(b.datahora_fim_formatada || null) ? 1 : -1)
					: (new Date(a.datahora_fim_formatada || null) > new Date(b.datahora_fim_formatada || null) ? -1 : 1));
			} else if (this.state.ordenacao.tempo) {
				lista.sort((a, b) => this.state.ordenacao.tempo == 1 
					? ((a.tempo_minutos || 0) > (b.tempo_minutos || 0) ? 1 : -1) 
					: ((a.tempo_minutos || 0) > (b.tempo_minutos || 0) ? -1 : 1));
			} else if (this.state.ordenacao.nome_tipo) {
				lista.sort((a, b) => this.state.ordenacao.nome_tipo == 1 
					? (a.nome_tipo > b.nome_tipo ? 1 : -1) 
					: (a.nome_tipo > b.nome_tipo ? -1 : 1));
			}

			return lista;
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	montarCard(nome, valor) {

		return (
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-3" 
				style={{ cursor: 'pointer' }}
				onClick={() => {}}>
				<div class="small-box"
					style={{
						backgroundColor: 'rgb(31, 48, 102, 0.9)'
					}}>
					<div class="inner">
						<h5 style={{ textAlign: 'center', color: '#ffffff', fontSize: 16 }}>{nome}</h5>
						<h4 style={{ textAlign: 'center', color: '#ffffff', fontSize: 22 }}>{valor}</h4>
					</div>
				</div>
			</div>
		)
	}

	montarTela() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let acessoCliente = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente;
		let indicadores = this.props.usuarioCarregado && (!this.props.usuarioCarregado.acesso_cliente || this.props.usuarioCarregado.track_indicadores);

		let listaFiltrada = this.filtrar();

		const telaMobile = window.innerWidth < 1247;
		
		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				
				{this.state.registroModal ? this.modalShipping() : null}
				
				{this.state.registroModalOcorrencia ? this.modalOcorrencia() : null}

				{this.state.contatosModal ? this.modalContatos() : null}

				{this.modalConfiguracao()}

				<ContentCardHeader paddingBottom={0}>

					<Row>
						{this.montarCard('Tempo Médio para Solucionar', this.props.cards.tempo_medio_solucao_minutos || '-')}
						{this.montarCard('Tempo com Ocorrências Abertas', this.props.cards.tempo_ocorrencia_aberta_minutos || '-')}
						{this.montarCard('Tempo sem Alertas', this.props.cards.tempo_sem_alerta || '-')}
						{this.montarCard('Abertos', this.props.cards.quantidade_abertos || 'Nenhum')}
					</Row>
					
					<Row style={{ display: 'flex', flexDirection: 'row-reverse' }}>					
						
						<Grid cols='12 12 10 10'>
							
							<Row>					
								
								<div style={{ width: 350, marginLeft: 4 }}>
									<div class='form-group'>
										<label htmlFor='pesquisa_geral'>Pesquisar</label>
										<div class='input-group' id='pesquisar'>
											<input 
												type='text'
												name='pesquisa_geral'
												class='form-control datetimepicker-input'
												data-target='#pesquisar'
												placeholder='Adicione + para combinar pesquisas'
												value={this.state.pesquisarAux}
												onChange={e => {
													this.setState({ ...this.state, pesquisarAux: e.target.value });
												}}
												onKeyDown={e => {
													if (e.key === 'Enter') {
														this.setState({ ...this.state, pesquisar: this.state.pesquisarAux });
													}
												}} />
											<div type='button' class='input-group-append' data-target='#pesquisar'>
												<div 
													class='input-group-text'
													onClick={e => {
														this.setState({ ...this.state, pesquisar: this.state.pesquisarAux });
													}}>
													<i class='fas fa-search'></i></div>
											</div>
										</div>
									</div>
								</div>

								<SelectNovo
									label='Rumo'
									multi
									options={this.props.listaRumos}
									cols='12 6 2 2'
									placeholder='Selecione'
									multiple={true}
									minWidth={250}
									value={this.state.filtro.rumos}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												rumos: value.map(item => item.value)
											}
										});
									}} />

								<SelectNovo
									label='Fronteira'
									multi
									options={this.props.listaFronteiras.map(item => ({ id: item.fronteira, valor: item.fronteira }))}
									cols='12 6 2 2'
									placeholder='Selecione'
									multiple={true}
									minWidth={400}
									value={this.state.filtro.fronteiras}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												fronteiras: value.map(item => item.value)
											}
										});
									}} />

								<SelectNovo
									label='Operação'
									multi
									options={this.props.listaOperacoes}
									cols='12 6 2 2'
									placeholder='Selecione'
									multiple={true}
									minWidth={400}
									value={this.state.filtro.operacoes}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												operacoes: value.map(item => item.value)
											}
										});
									}} />

								<SelectNovo
									label='Negociador'
									multi
									options={this.props.listaNegociadores.map(item => ({ id: item.id_negociador, valor: item.negociador }))}
									cols='12 6 2 2'
									placeholder='Selecione'
									multiple={true}
									minWidth={400}
									value={this.state.filtro.negociadores}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												negociadores: value.map(item => item.value)
											}
										});
									}} />
								
								<div  style={{ display: 'flex', marginTop: 8, marginLeft: 10, flexWrap: 'wrap'  }}>
																											
									<div style={{ }}>
										<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
											onClick={() => {
												this.props.getLista(this.state.filtro, true);
												this.props.getListaCards();
											}}>
											<i class='fas fa-sync-alt'></i> Atualizar
										</a>

										<a class='btn btn-app bg-secondary' style={{ marginLeft: 2, minWidth: 75 }}
											onClick={() => {												
												this.setModalConfiguracao(this.props.registroConfiguracao);
											}}>
											<i class='fas fa-cog'></i> Configurar
										</a>
									</div>
								</div>

							</Row>
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody paddingTop={0}>
					{this.state.modoTela == 'lista' &&
					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? '100%'
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 360}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 280}px`
										: `${window.innerHeight - 290}px`
									)
								)
							)
						}}>
					<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? '100%'
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 360}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 280}px`
										: `${window.innerHeight - 290}px`
									)
								)
							)}>
						<THead>

							<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { solicitacao: this.getNovaOrdenacao(this.state.ordenacao.solicitacao) }})} 
									sticky minWidth={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Solicitação'>Sol. {this.getIconeOrdenacao(this.state.ordenacao.solicitacao)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { shipping: this.getNovaOrdenacao(this.state.ordenacao.shipping) }})} 
									sticky minWidth={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Shipping'>SC {this.getIconeOrdenacao(this.state.ordenacao.shipping)}</Th>	
													
								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { cavalo: this.getNovaOrdenacao(this.state.ordenacao.cavalo) }})} 
									sticky minWidth={60} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Cavalo {this.getIconeOrdenacao(this.state.ordenacao.cavalo)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { carreta: this.getNovaOrdenacao(this.state.ordenacao.carreta) }})} 
									sticky minWidth={60} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Carreta {this.getIconeOrdenacao(this.state.ordenacao.carreta)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { cliente: this.getNovaOrdenacao(this.state.ordenacao.cliente) }})} 
									sticky minWidth={150} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Cliente {this.getIconeOrdenacao(this.state.ordenacao.cliente)}</Th>
								
								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { rota: this.getNovaOrdenacao(this.state.ordenacao.rota) }})} 
									sticky minWidth={200} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Rota {this.getIconeOrdenacao(this.state.ordenacao.rota)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { fronteira: this.getNovaOrdenacao(this.state.ordenacao.fronteira) }})} 
									sticky minWidth={250} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Fronteira {this.getIconeOrdenacao(this.state.ordenacao.fronteira)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { posicao: this.getNovaOrdenacao(this.state.ordenacao.posicao) }})} 
									sticky minWidth={250} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Posição {this.getIconeOrdenacao(this.state.ordenacao.posicao)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { datahora_inicio_formatada: this.getNovaOrdenacao(this.state.ordenacao.datahora_inicio_formatada) }})} 
									sticky minWidth={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Início {this.getIconeOrdenacao(this.state.ordenacao.datahora_inicio_formatada)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { tempo: this.getNovaOrdenacao(this.state.ordenacao.tempo) }})} 
									sticky minWidth={60} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Tempo {this.getIconeOrdenacao(this.state.ordenacao.tempo)}</Th>

								<Th paddingTop={2} paddingBottom={2} onClick={() => this.setState({ ...this.state, ordenacao: { nome_tipo: this.getNovaOrdenacao(this.state.ordenacao.nome_tipo) }})} 
									sticky minWidth={60} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Tipo {this.getIconeOrdenacao(this.state.ordenacao.nome_tipo)}</Th>

								<Th paddingTop={2} paddingBottom={2} alignCenter sticky minWidth={10} backgroundColor={'#1F3066'} color={'#ffffff'}>
									<a href='#'
										title={!this.state.resumido ? 'Mostrar as informações resumidas' : 'Mostrar as informações completas com quebra de linha'}
										style={{ color: '#ffffff', fontSize: 18 }}
										onClick={(event) => {
											event.preventDefault();
											this.setState({
												...this.state,
												resumido: !this.state.resumido
											});
										}} >
										<i class={`${this.state.resumido ? 'fas fa-expand' : 'fas fa-compress'}`} />
									</a>
								</Th>
									
							</Tr>
						</THead>
						<TBody>
							{listaFiltrada.map((item, i) => {
											
								return (
									<>
										<Tr key={item.id_evento} 
											backgroundColor={this.state.linhaSelecionada == item.id_evento ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											>										
																			
											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={50} color={'#000'} alignCenter small>{item.solicitacao_carga_id}</Td>
											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={50} color={'#000'} alignCenter small>{item.shipping_code_id}</Td>
											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={50} color={'#000'} alignCenter small>{item.cavalo}</Td>
											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={50} color={'#000'} alignCenter small>{item.carreta}</Td>
											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={150} color={'#000'} alignCenter small noWrap={this.state.resumido}>{item.negociador}</Td>
											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={200} color={'#000'} alignCenter small noWrap={this.state.resumido}>{item.rota}</Td>
											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={250} color={'#000'} alignCenter small noWrap={this.state.resumido}>{item.nome_fronteira}</Td>

											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={250} color={'#000'} alignCenter small noWrap={this.state.resumido}>{item.posicao}</Td>

											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={100} color={'#000'} alignCenter small noWrap={this.state.resumido}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio_formatada)}</Td>

											<Td onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={50} color={'#000'} alignCenter small noWrap={this.state.resumido}>{item.tempo}</Td>

											<Td colspan={2} onClick={() => setLinhaSelecionada(item.id_evento)} minWidth={50} color={'#000'} alignCenter small noWrap={this.state.resumido} title={item.descricao_tipo}>{item.nome_tipo}</Td>
										</Tr>
									</>
								)
							})}
						</TBody>
					</Table>
					</div>}
					
					{this.state.modoTela == 'mapa' ? this.modoMapa(listaFiltrada) : null}

					{this.state.modoTela == 'bi' ? this.modoBI() : null}

				</ContentCardBody>
			</ContentCard>
		);
	}

	modoMapa(lista) {

		return (
			<div 
				style={{ 
					backgroundColor: '#1F3066',
					marginLeft: -8,
					marginRight: -8,
					marginBottom: -8,
					paddingTop: 1,
					paddingLeft: 8,
					paddingRight: 8,
					paddingBottom: 8
				}}>
				<div 
					style={{ height: window.innerWidth < 768 ? window.innerHeight - 60 : (window.innerWidth < 1799 ? '72vh' : `${(window.innerHeight - 60) * 0.0926}vh`) }} >
					
					<MapLeaflet
						zIndex={0}
						coordenadas={lista.filter(item => item.cavalo && item.veiculo_latitude && item.veiculo_longitude && !item.data_termino_descarga).map(item => {

							let corTransitTime = 'success';
							if (item.transit_time < 100 && item.datahora_previsao_real) {
								if (!item.data_inicio_carga) {
									if (item.data_previsao_carga && new Date(item.datahora_previsao_real).getTime() > new Date(item.data_previsao_carga).getTime()) {
										corTransitTime = 'danger';
									}
								} else if (item.fronteira && item.data_termino_carga && !item.data_entrada_fronteira) {
									if (item.data_prev_fronteira && new Date(item.datahora_previsao_real).getTime() > new Date(item.data_prev_fronteira).getTime()) {
										corTransitTime = 'danger';
									}
								} else if (((!item.fronteira && item.data_termino_carga) || (item.fronteira && item.data_liberacao_fronteira)) && !item.data_inicio_descarga) {
									if (item.data_previsao_descarga && new Date(item.datahora_previsao_real).getTime() > new Date(item.data_previsao_descarga).getTime()) {
										corTransitTime = 'danger';
									}
								}
							}
							
							let previsaoCarga = null;
							let previsaoFronteira = null;
							let previsaoDescarga = null;
							if (item.rumo != 'NAC') {
								if (!item.data_inicio_carga) {
									previsaoCarga = DateFormat.formatarDataHoraSqlParaTela(item.data_previsao_carga);
								} else if (item.data_termino_carga && !item.data_entrada_fronteira) {
									previsaoFronteira = DateFormat.formatarDataHoraSqlParaTela(item.data_prev_fronteira);
								} else if (item.data_liberacao_fronteira && !item.data_inicio_descarga) {
									previsaoDescarga = DateFormat.formatarDataHoraSqlParaTela(item.data_previsao_descarga);
								}
							} else {
								if (!item.data_inicio_carga) {
									previsaoCarga = DateFormat.formatarDataHoraSqlParaTela(item.data_previsao_carga);
								} else if (item.data_termino_carga && !item.data_inicio_descarga) {
									previsaoDescarga = DateFormat.formatarDataHoraSqlParaTela(item.data_previsao_descarga);
								}
							}

							return {
								id: item.solicitacao_carga_id,
								titulo: item.cavalo,
								body: (
									<div>
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Documento: {item.documento}</p>
										{item.origem &&
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Origem: {(item.origem || '')}</p>}
										{item.origem &&
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Destino: {(item.destino || '')}</p>}
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Cliente: {(item.negociador || '')}</p>
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Referência: {(item.observacao || '')}</p>
										{previsaoCarga &&
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Prev. Carga: {previsaoCarga}</p>}
										{previsaoFronteira &&
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Prev. Fronteira: {previsaoFronteira}</p>}
										{previsaoDescarga &&
										<p style={{ paddingBottom: 0, marginBottom: 0 }}>Prev. Descarga: {previsaoDescarga}</p>}
									</div>
								),
								latitude: item.veiculo_latitude,
								longitude: item.veiculo_longitude,
								direcao: item.rumo == 'RS' ? 'S' : 'N',
								status: corTransitTime
							}
						})}
						zoom={4}
						latitude={'-28.381875'}
						longitude={'-53.937355'}
						onChange={(coordenadas) => {
							
						}} />
				</div>
			</div>
		);
	}

	modoBI() {

		return (
			<iframe title="KPI - SC JOHNSON BR" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=1c35a469-7d5e-4dc5-8775-f9a7329519e5&autoAuth=true&ctid=370235b0-bf1e-47ec-ab6e-3b6fa12c7853" frameborder="0" allowFullScreen="true"></iframe>
		)

		return (
			<PowerBIEmbed
				embedConfig={{
					type: 'dashboard',   // Embed type
					id: '1c35a469-7d5e-4dc5-8775-f9a7329519', // Report ID
					embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=1c35a469-7d5e-4dc5-8775-f9a7329519e5&autoAuth=true&ctid=370235b0-bf1e-47ec-ab6e-3b6fa12c7853',
					accessToken: '370235b0-bf1e-47ec-ab6e-3b6fa12c7853',
					tokenType: models.TokenType.Embed,
					settings: {
						filterPaneEnabled: false,
						navContentPaneEnabled: false
					}
				}}
				eventHandlers={
					[
						['loaded', function () {console.log('Report loaded');}],
						['rendered', function () {console.log('Report rendered');}],
						['error', function (event) {console.log(event.detail);}],
						['visualClicked', () => console.log('visual clicked')],
						['pageChanged', (event) => console.log(event)],
					]
				}
				/>
		)

		return (

			<iframe
				title='Power BI'
				src={`https://app.powerbi.com/view?r=eyJrIjoiZmYzMjU0NGUtZmZiOC00MWNjLTg4OTgtNjFiZGU4NGVjOTg4IiwidCI6IjM3MDIzNWIwLWJmMWUtNDdlYy1hYjZlLTNiNmZhMTJjNzg1MyJ9`}
				style={{
					width: '100%', 
					height: window.innerHeight - 180
				}}
				frameBorder="0"
				allowFullScreen="true"
				/>
		)
	}

	montarExcel(listaFiltrada, acessoCliente, indicadores) {


		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={listaFiltrada.map(item => ({
				...item,
				transit_time: `${item.transit_time}%`,
				data_previsao_carga: DateFormat.formatarDataHoraSqlParaTela(item.data_previsao_carga),
				data_inicio_carga: DateFormat.formatarDataHoraSqlParaTela(item.data_inicio_carga),
				data_termino_carga: DateFormat.formatarDataHoraSqlParaTela(item.data_termino_carga),
				data_entrada_aduana_origem: DateFormat.formatarDataHoraSqlParaTela(item.data_entrada_aduana_origem),
				data_liberacao_aduana_origem: DateFormat.formatarDataHoraSqlParaTela(item.data_liberacao_aduana_origem),
				data_prev_fronteira: DateFormat.formatarDataHoraSqlParaTela(item.data_prev_fronteira),
				data_entrada_fronteira: DateFormat.formatarDataHoraSqlParaTela(item.data_entrada_fronteira),
				data_autorizacao_ingresso_fronteira: DateFormat.formatarDataHoraSqlParaTela(item.data_autorizacao_ingresso_fronteira),
				dt_entrada_aduana_front_org: DateFormat.formatarDataHoraSqlParaTela(item.dt_entrada_aduana_front_org),
				dt_liberacao_aduana_front_org: DateFormat.formatarDataHoraSqlParaTela(item.dt_liberacao_aduana_front_org),
				dt_entrada_aduana_front_dest: DateFormat.formatarDataHoraSqlParaTela(item.dt_entrada_aduana_front_dest),
				dt_liberacao_aduana_front_dest: DateFormat.formatarDataHoraSqlParaTela(item.dt_liberacao_aduana_front_dest),
				data_liberacao_fronteira: DateFormat.formatarDataHoraSqlParaTela(item.data_liberacao_fronteira),
				data_prev_aduana_destino: DateFormat.formatarDataHoraSqlParaTela(item.data_prev_aduana_destino),
				data_entrada_aduana_destino: DateFormat.formatarDataHoraSqlParaTela(item.data_entrada_aduana_destino),
				data_liberacao_aduana_destino: DateFormat.formatarDataHoraSqlParaTela(item.data_liberacao_aduana_destino),
				data_previsao_descarga: DateFormat.formatarDataHoraSqlParaTela(item.data_previsao_descarga),
				data_inicio_descarga: DateFormat.formatarDataHoraSqlParaTela(item.data_inicio_descarga),
				data_termino_descarga: DateFormat.formatarDataHoraSqlParaTela(item.data_termino_descarga),

				indicador_carga: !item.data_previsao_carga ? '' : ((item.chegada_carga_dias + item.chegada_carga_horas + item.chegada_carga_minutos) > 0 ? 'Atrasado' : 'Adiantado'),
				indicador_carga_descritivo: parseFloat(FormatUtils.formatarValorBanco(FormatUtils.formatarValorTela(item.janela_carga_dias + (item.janela_carga_horas / 24) + (item.janela_carga_minutos / 60 / 24) > 0 ? item.janela_carga_dias + (item.janela_carga_horas / 24) + (item.janela_carga_minutos / 60 / 24) : 0, 3), 3)),

				indicador_fronteira: !item.data_prev_fronteira ? '' : ((item.chegada_fronteira_dias + item.chegada_fronteira_horas + item.chegada_fronteira_minutos) > 0 ? 'Atrasado' : 'Adiantado'),
				indicador_fronteira_descritivo: parseFloat(FormatUtils.formatarValorBanco(FormatUtils.formatarValorTela(item.janela_fronteira_dias + (item.janela_fronteira_horas / 24) + (item.janela_fronteira_minutos / 60 / 24) > 0 ? item.janela_fronteira_dias + (item.janela_fronteira_horas / 24) + (item.janela_fronteira_minutos / 60 / 24) : 0, 3), 3)),

				indicador_aduana_destino: !item.data_prev_aduana_destino ? '' : ((item.chegada_aduana_destino_dias + item.chegada_aduana_destino_horas + item.chegada_aduana_destino_minutos) > 0 ? 'Atrasado' : 'Adiantado'),
				indicador_aduana_destino_descritivo: parseFloat(FormatUtils.formatarValorBanco(FormatUtils.formatarValorTela(item.janela_aduana_destino_dias + (item.janela_aduana_destino_horas / 24) + (item.janela_aduana_destino_minutos / 60 / 24) > 0 ? item.janela_aduana_destino_dias + (item.janela_aduana_destino_horas / 24) + (item.janela_aduana_destino_minutos / 60 / 24) : 0, 3), 3)),

				indicador_descarga: !item.data_previsao_descarga ? '' : ((item.chegada_descarga_dias + item.chegada_descarga_horas + item.chegada_descarga_minutos) > 0 ? 'Atrasado' : 'Adiantado'),
				indicador_descarga_descritivo: parseFloat(FormatUtils.formatarValorBanco(FormatUtils.formatarValorTela(item.janela_descarga_dias + (item.janela_descarga_horas / 24) + (item.janela_descarga_minutos / 60 / 24) > 0 ? item.janela_descarga_dias + (item.janela_descarga_horas / 24) + (item.janela_descarga_minutos / 60 / 24) : 0, 3), 3)),

				lead_time: parseFloat(FormatUtils.formatarValorBanco(FormatUtils.formatarValorTela(item.lead_time_dias + (item.lead_time_horas / 24) + (item.lead_time_minutos / 60 / 24) > 0 ? item.lead_time_dias + (item.lead_time_horas / 24) + (item.lead_time_minutos / 60 / 24) : 0, 3), 3)),

				tipo_ocorrencia_1: (item.ocorrencias || [])[0] ? (item.ocorrencias || [])[0].tipo_ocorrencia : '',
				responsavel_ocorrencia_1: (item.ocorrencias || [])[0] ? ((item.ocorrencias || [])[0].responsabilidade == 0 ? 'Cliente' : 'Letsara') : '',
				inicio_ocorrencia_1: (item.ocorrencias || [])[0] ? DateFormat.formatarDataHoraSqlParaTela((item.ocorrencias || [])[0].data_inicio) : '',
				fim_ocorrencia_1: (item.ocorrencias || [])[0] ? DateFormat.formatarDataHoraSqlParaTela((item.ocorrencias || [])[0].data_termino) : '',

				tipo_ocorrencia_2: (item.ocorrencias || [])[1] ? (item.ocorrencias || [])[1].tipo_ocorrencia : '',
				responsavel_ocorrencia_2: (item.ocorrencias || [])[1] ? ((item.ocorrencias || [])[1].responsabilidade == 0 ? 'Cliente' : 'Letsara') : '',
				inicio_ocorrencia_2: (item.ocorrencias || [])[1] ? DateFormat.formatarDataHoraSqlParaTela((item.ocorrencias || [])[1].data_inicio) : '',
				fim_ocorrencia_2: (item.ocorrencias || [])[1] ? DateFormat.formatarDataHoraSqlParaTela((item.ocorrencias || [])[1].data_termino) : '',

				tipo_ocorrencia_3: (item.ocorrencias || [])[2] ? (item.ocorrencias || [])[2].tipo_ocorrencia : '',
				responsavel_ocorrencia_3: (item.ocorrencias || [])[2] ? ((item.ocorrencias || [])[2].responsabilidade == 0 ? 'Cliente' : 'Letsara') : '',
				inicio_ocorrencia_3: (item.ocorrencias || [])[2] ? DateFormat.formatarDataHoraSqlParaTela((item.ocorrencias || [])[2].data_inicio) : '',
				fim_ocorrencia_3: (item.ocorrencias || [])[2] ? DateFormat.formatarDataHoraSqlParaTela((item.ocorrencias || [])[2].data_termino) : '',
				classificada: item.classificada ? 'Sim' : ''
			}))} name='Inconformidade'>
				{[
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={1} label='Transit Time' value='transit_time' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={2} label='Ship.' value='shipping_code_id' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={3} label='Sol.' value='solicitacao_carga_id' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={4} label='Referência' value='observacao' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={5} label='Fatura/Nota Fiscal' value='fatura' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={6} label='Documento' value='documento' /> },
					{ internacional: false, adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={7} label='Classificada' value='classificada' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={8} label='Cavalo' value='cavalo' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={9} label='Carreta' value='carreta' /> },
					{ internacional: false, adm: true,  cliente: false, indicador: false, componente: <ExcelColumn key={10} label='Cliente' value='negociador' /> },
					{ internacional: false, adm: false, cliente: true,  indicador: false, componente: <ExcelColumn key={11} label='Remetente' value='nome_remetente_sol' /> },
					{ internacional: false, adm: false, cliente: true,  indicador: false, componente: <ExcelColumn key={12} label='Destinatário' value='nome_destinatario_sol' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={13} label='Rota' value='rota' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={14} label='Rumo' value='rumo' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={15} label='Fronteira' value='nome_fronteira' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={16} label='Previsão Carga' value='data_previsao_carga' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={17} label='Chegada Carga' value='data_inicio_carga' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={18} label='Saída Carga' value='data_termino_carga' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={19} label='Chegada Aduana Origem' value='data_entrada_aduana_origem' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={20} label='Liberação Aduana Origem' value='data_liberacao_aduana_origem' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={21} label='Previsão Fronteira' value='data_prev_fronteira' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={22} label='Chegada Fronteira' value='data_entrada_fronteira' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={23} label='Autorização Ingresso fronteira' value='data_autorizacao_ingresso_fronteira' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={24} label='Chegada Aduana Fronteira Origem' value='dt_entrada_aduana_front_org' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={25} label='Liberação Aduana Fronteira Origem' value='dt_liberacao_aduana_front_org' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={26} label='Chegada Aduana Fronteira Destino' value='dt_entrada_aduana_front_dest' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={27} label='Liberação Aduana Fronteira Destino' value='dt_liberacao_aduana_front_dest' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={28} label='Liberação Fronteira' value='data_liberacao_fronteira' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={29} label='Previsão Aduana Destino' value='data_prev_aduana_destino' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={30} label='Chegada Aduana Destino' value='data_entrada_aduana_destino' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={31} label='Liberação Aduana Destino' value='data_liberacao_aduana_destino' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={32} label='Previsão Descarga' value='data_previsao_descarga' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={33} label='Chegada Descarga' value='data_inicio_descarga' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={34} label='Saída Descarga' value='data_termino_descarga' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={34} label='JC' value='indicador_carga' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={35} label='JF' value='indicador_fronteira' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={36} label='JAD' value='indicador_aduana_destino' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={37} label='JD' value='indicador_descarga' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={37} label='Tempo de Permanência Carga' value='indicador_carga_descritivo' type='number' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={38} label='Tempo de Permanência Fronteira' value='indicador_fronteira_descritivo' type='number' /> },
					{ internacional: true,  adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={39} label='Tempo de Permanência Aduana Destino' value='indicador_aduana_destino_descritivo' type='number' /> },
					{ internacional: false, adm: true,  cliente: true,  indicador: true,  componente: <ExcelColumn key={40} label='Tempo de Permanência Descarga' value='indicador_descarga_descritivo' type='number' /> },
					{ internacional: false,  adm: true,  cliente: true,  indicador: false, componente: <ExcelColumn key={41} label='Lead Time' value='lead_time' type='number' /> },

					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={42} label='Tipo Ocorrência 1' value='tipo_ocorrencia_1' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={43} label='Responsavel Ocorrência 1' value='responsavel_ocorrencia_1' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={44} label='Início Ocorrência 1' value='inicio_ocorrencia_1' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={45} label='Fim Ocorrência 1' value='fim_ocorrencia_1' /> },

					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={46} label='Tipo Ocorrência 2' value='tipo_ocorrencia_2' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={47} label='Responsavel Ocorrência 2' value='responsavel_ocorrencia_2' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={48} label='Início Ocorrência 2' value='inicio_ocorrencia_2' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={49} label='Fim Ocorrência 2' value='fim_ocorrencia_2' /> },

					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={50} label='Tipo Ocorrência 3' value='tipo_ocorrencia_3' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={51} label='Responsavel Ocorrência 3' value='responsavel_ocorrencia_3' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={52} label='Início Ocorrência 3' value='inicio_ocorrencia_3' /> },
					{ internacional: false,  adm: true,  cliente: false,  indicador: false, componente: <ExcelColumn key={53} label='Fim Ocorrência 3' value='fim_ocorrencia31' /> }

				].filter(item => {

					if (acessoCliente && !item.cliente) {
						return false;
					}
					if (!acessoCliente && !item.adm) {
						return false;
					}
					if (!this.state.filtro.internacional && item.internacional) {
						return false;
					}
					if (acessoCliente && !indicadores && item.indicador) {
						return false;
					}

					return true;

				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

	controleFavoritos(idShippingCode) {
		let lista = JSON.parse(Cookies.get('shippingsFavoritos') || '[]');

		if (this.isFavorito(idShippingCode)) {
			lista = lista.filter(item => item != idShippingCode);
		} else {
			lista.push(idShippingCode);
		}

		lista = lista.filter(item => (this.props.lista || []).filter(shipping => shipping.shipping_code_id == item).length);

		this.setState({ ...this.state, listaFavoritos: lista });

		Cookies.set('shippingsFavoritos', JSON.stringify(lista), { expires: 15 });
	}

	isFavorito(idShippingCode) {
		return (this.state.listaFavoritos || []).filter(shipping => shipping == idShippingCode).length > 0;
	}
	
	modalShipping() {

		const qtdSolicitacoes = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).length;
		let mostrarColunaSolicitacao = false;
		this.props.listaPrevisoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).map(item => {
			if ((item.solicitacoes || []).filter(sol => sol).length != qtdSolicitacoes) {
				mostrarColunaSolicitacao = true;
			}
		});

		let solicitacao = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id)[0] || {};

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
							<h4 class='modal-title'>Shipping Code: {this.state.registroModal.shipping_code_id} <i class={this.isFavorito(this.state.registroModal.shipping_code_id) ? 'fas fa-star' : 'far fa-star'} title={this.isFavorito(this.state.registroModal.shipping_code_id) ? 'Remover dos favoritos' : 'Adicionar aos favoritos'} onClick={() => this.controleFavoritos(this.state.registroModal.shipping_code_id)} style={{ marginLeft: 8, cursor: 'pointer' }}></i></h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, registroModal: null })}>
								<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ height: window.innerHeight * 0.8, overflowY: 'scroll' }}>

							<h6>Placas</h6>

							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Solicitação</Th>
										<Th alignCenter>Cavalo</Th>
										<Th alignCenter>Carreta</Th>
										<Th alignCenter>Motorista</Th>
										<Th alignCenter>Local</Th>
										<Th alignCenter>Latitude/Longitude</Th>
										<Th alignCenter>Status</Th>
									</Tr>
								</THead>
								<TBody>
									{this.props.lista.filter(item => item.solicitacao_carga_id == this.state.registroModal.solicitacao_carga_id).map(item => (
										<Tr key={item.solicitacao_carga_id}>
											<Td alignCenter small>{item.solicitacao_carga_id || ''}</Td>
											<Td alignCenter small>{item.cavalo || ''}</Td>
											<Td alignCenter small>{item.carreta || ''}</Td>
											<Td alignCenter small>{item.motorista || ''}</Td>
											<Td alignCenter small>{item.veiculo_referencia || ''}</Td>
											<Td alignCenter small>
												{(item.veiculo_latitude && item.veiculo_longitude) &&
												<a target='blank' href={`https://www.google.com/maps/place/${item.veiculo_latitude},${item.veiculo_longitude}`}>
													{item.veiculo_latitude}, {item.veiculo_longitude}
												</a>}
											</Td>
											<Td alignCenter small>{item.veiculo_status || ''}</Td>
										</Tr>
									))}
								</TBody>
							</Table>

							<Grid cols="12 12 12 12">
								<div style={{ width: "100%", height: 500 }}>
									<MapLeaflet
										coordenadas={this.props.lista.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id && item.veiculo_latitude && item.veiculo_longitude)
											.map(item => ({
												id: item.solicitacao_carga_id,
												titulo: item.cavalo,
												latitude: item.veiculo_latitude,
												longitude: item.veiculo_longitude,
												direcao: this.state.registroModal.rumo == 'RS' ? 'S' : 'N'
											}))}
										zoom={4}
										latitude={'-28.381875'}
										longitude={'-53.937355'}
										onChange={(coordenadas) => {
										}}
									/>
								</div>
							</Grid>

						</div>
						{/*<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => this.setState({ ...this.state, registroModal: null })}>Fechar</button>
						</div>*/}
					</div>
				</div>
			</div>
        );
    }

	modalOcorrencia() {

		const qtdSolicitacoes = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id).length;
		let mostrarColunaSolicitacao = false;
		this.props.listaPrevisoes.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id).map(item => {
			if ((item.solicitacoes || []).filter(sol => sol).length != qtdSolicitacoes) {
				mostrarColunaSolicitacao = true;
			}
		});

		let solicitacao = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id)[0] || {};

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
							<h4 class='modal-title'>Shipping Code: {this.state.registroModalOcorrencia.shipping_code_id}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, registroModalOcorrencia: null })}>
								<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll', marginBottom: 80 }}>

							<h6>Ocorrências</h6>

							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Tipo</Th>
										<Th alignCenter>Responsável</Th>
										<Th alignCenter>Início</Th>
										<Th alignCenter>Fim</Th>
										<Th alignCenter>Descrição</Th>
										<Th alignCenter>Usuário</Th>
									</Tr>
								</THead>
								<TBody>
									{this.props.listaOcorrencias.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id).map(item => (
										<Tr key={item.id_ocorrencia}>
											<Td alignCenter small>{item.descricao_tipo_ocorrencia || ''}</Td>
											<Td alignCenter small>{item.responsabilidade == 0 ? 'Cliente' : 'Letsara'}</Td>
											<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.data_inicio)}</Td>
											<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.data_termino)}</Td>
											<Td alignCenter small>{item.comentario || ''}</Td>
											<Td alignCenter small>{item.usuario_inclusao || ''}</Td>
										</Tr>
									))}
								</TBody>
							</Table>

						</div>
					</div>
				</div>
			</div>
        );
    }

	modalContatos() {

        return (
			<div class='modal fade show' id='modal-md' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
							<h4 class='modal-title'>Contatos</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, contatosModal: null })}>
								<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll' }}>

							<h6>Placas</h6>

							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Nome</Th>
										<Th alignCenter>Celular</Th>
										<Th alignCenter>WhatsApp</Th>
									</Tr>
								</THead>
								<TBody>
									{(this.props.usuarioCarregado.contatos || []).map(item => (
										<Tr key={item.id}>
											<Td alignCenter>{item.nome}</Td>
											<Td alignCenter>{FormatUtils.formatarTelefone(item.telefone)}</Td>
											<Td alignCenter>
												<a class='btn btn-success' target='blank' href={`https://api.whatsapp.com/send?phone=+55${item.telefone}&text=${encodeURI(`Olá ${item.nome}`)}`}>
													<i style={{ fontSize: 24 }} class='fab fa-whatsapp'></i>
												</a>
											</Td>
										</Tr>
									))}
								</TBody>
							</Table>
						</div>
					</div>
				</div>
			</div>
        );
    }
	setModalConfiguracao(registro) {
		this.setState({
			registroConfiguracao: registro
		});
	}

	modalConfiguracao() {

		if (!this.state.registroConfiguracao) {
			return null;
		}

		const readOnly = !this.permissaoConfigurar ? 'readOnly' : null;
		

        return (
			<>
				<div className="modal-backdrop fade show" />
				<div class='modal fade show'
					id='modal-xl'
					style={{ display: 'block' }}
					aria-modal='true'>
					<div class='modal-dialog modal-xl'>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>Configuração</h4>

								<button
									type='button'
									className='close custom-close'
									data-dismiss='modal'
									aria-label='Close'
									style={{
										marginLeft: 4
									}}
									onClick={() => this.setState({ ...this.state, registroConfiguracao: null })} >
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 36 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{}}>
								<Row>
									<LabelAndInputNumber
										label='Distância para chegada no local de carga (metros)' placeholder='Informe'
										cols='12 12 6 6'
										casas={0}
										readOnly={readOnly}
										value={this.state.registroConfiguracao.distancia_chegada_carga}
										onChange={data => {
											this.setModalConfiguracao({
												...this.state.registroConfiguracao,
												distancia_chegada_carga: data.target.value
											});
										}} />
									
									<LabelAndInputNumber
										label='Distância para saída do local carga (metros)' placeholder='Informe'
										cols='12 12 6 6'
										casas={0}
										readOnly={readOnly}
										value={this.state.registroConfiguracao.distancia_saida_carga}
										onChange={data => {
											this.setModalConfiguracao({
												...this.state.registroConfiguracao,
												distancia_saida_carga: data.target.value
											});
										}} />
										
									<LabelAndInputNumber
										label='Distância para chegada no local de descarga (metros)' placeholder='Informe'
										cols='12 12 6 6'
										casas={0}
										readOnly={readOnly}
										value={this.state.registroConfiguracao.distancia_chegada_descarga}
										onChange={data => {
											this.setModalConfiguracao({
												...this.state.registroConfiguracao,
												distancia_chegada_descarga: data.target.value
											});
										}} />

									<LabelAndInputNumber
										label='Distância para saída do local de desarga (metros)' placeholder='Informe'
										cols='12 12 6 6'
										casas={0}
										readOnly={readOnly}
										value={this.state.registroConfiguracao.distancia_saida_descarga}
										onChange={data => {
											this.setModalConfiguracao({
												...this.state.registroConfiguracao,
												distancia_saida_descarga: data.target.value
											});
										}} />
								</Row>

								{this.permissaoConfigurar &&
								<Row alignCenter>
									<Grid cols='6 6 4 3'>
										<Button
											text='Salvar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => {
												this.props.alterarConfiguracao(this.state.registroConfiguracao);
												this.setModalConfiguracao(null);
											}} />
									</Grid>
								</Row>}
							</div>
						</div>
					</div>
				</div>
			</>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.reportsInconformidade.modoTela,
	aguardando: state.reportsInconformidade.aguardando,
	lista: state.reportsInconformidade.lista,
	cards: state.reportsInconformidade.cards,
	listaFronteiras: state.reportsInconformidade.listaFronteiras,
	listaNegociadores: state.reportsInconformidade.listaNegociadores,
	listaRumos: state.reportsInconformidade.listaRumos,
	listaFarolAtraso: state.reportsInconformidade.listaFarolAtraso,
	listaOcorrencias: state.reportsInconformidade.listaOcorrencias,
	listaSolicitacoes: state.reportsInconformidade.listaSolicitacoes,
	listaPrevisoes: state.reportsInconformidade.listaPrevisoes,
	listaEventos: state.reportsInconformidade.listaEventos,
	listaPrevisoesEventos: state.reportsInconformidade.listaPrevisoesEventos,
	listaOperacoes: state.reportsInconformidade.listaOperacoes,
	filtro: state.reportsInconformidade.filtro,
	registroConfiguracao: state.reportsInconformidade.registroConfiguracao
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, getListaFronteiras, getListaNegociadores, getListaOperacoes, getLista, getListaOcorrencias, getListaCards,
	registrarAcesso, getConfiguracao, alterarConfiguracao, buscarPermissao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ReportsInconformidade);
